/**
 * Time Formatting Utilities
 * 
 * Functions for formatting durations and timestamps for display
 */

/**
 * Format seconds to MM:SS or HH:MM:SS
 * @param {number} seconds - Duration in seconds
 * @returns {string} Formatted duration string
 */
export function formatDuration(seconds) {
  // Handle negative values by clamping to 0
  const totalSeconds = Math.max(0, Math.floor(seconds));
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${minutes}:${String(secs).padStart(2, '0')}`;
}

/**
 * Format seconds to human-readable text
 * @param {number} seconds - Duration in seconds
 * @returns {string} Human-readable duration string
 */
export function formatDurationText(seconds) {
  // Handle negative values by clamping to 0
  const totalSeconds = Math.max(0, Math.floor(seconds));
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  
  if (hours > 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
  return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
}

/**
 * Format a duration as locale-independent hours and minutes.
 *
 * Calendar summaries use this clock-like format so the value remains compact
 * and consistent in both language modes (for example, 4h 39m becomes 04:39).
 * @param {number} seconds - Duration in seconds
 * @returns {string} Formatted duration as HH:MM
 */
export function formatClockDuration(seconds) {
  const safeSeconds = Number(seconds);
  const totalMinutes = Number.isFinite(safeSeconds) ? Math.max(0, Math.floor(safeSeconds / 60)) : 0;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
